import { lazy } from 'react';
import { Permission } from '@condo/domain';
import { Navigate } from 'react-router-dom';

import { ConfigIndexRedirect, ConfigLayout } from '@/features/administration/ui/ConfigLayout';

const SpotlightCataloguePage = lazy(() => import('./SpotlightCataloguePage'));
const SpotlightReportPage = lazy(() => import('./SpotlightReportPage'));

const InvestmentCaseConfigPage = lazy(() => import('./InvestmentCaseConfigPage'));
const AssetPartnerIcProfilesPage = lazy(() => import('./AssetPartnerIcProfilesPage'));
const DDAnswerSuggestionsPage = lazy(() => import('./DDAnswerSuggestionsPage'));
const RenovationStrategyScenariosPage = lazy(() => import('./RenovationStrategyScenariosPage'));
const SourcingCriteriaPage = lazy(() => import('./SourcingCriteriaPage'));

export const administrationRoutes = [
    {
        path: 'configuration',
        name: 'config',
        element: <ConfigLayout />,
        children: [
            {
                path: 'spotlights',
                name: 'config.spotlights',
                element: <SpotlightCataloguePage />,
                permissions: [Permission.SpotlightManage],
            },
            {
                path: 'spotlights/report',
                name: 'config.spotlight-report',
                element: <SpotlightReportPage />,
                permissions: [Permission.SpotlightReportView],
            },
            {
                index: true,
                element: <ConfigIndexRedirect />,
            },
            {
                path: 'investment-case-defaults',
                name: 'config.investment-case-defaults',
                element: <InvestmentCaseConfigPage />,
                permissions: [Permission.MFHInvestmentCaseAdminInputEdit],
            },
            {
                path: 'investment-case-feedback',
                name: 'config.investment-case-feedback',
                element: <Navigate to="/agents/conversations" replace />,
                permissions: [Permission.AgentChatViewAny, Permission.AgentFeedbackManage],
            },
            {
                path: 'agent-feedback',
                name: 'config.agent-feedback',
                element: <Navigate to="/agents/conversations" replace />,
                permissions: [Permission.AgentChatViewAny, Permission.AgentFeedbackManage],
            },
            {
                path: 'asset-partner-ic-profiles',
                name: 'config.asset-partner-ic-profiles',
                element: <AssetPartnerIcProfilesPage />,
                permissions: [Permission.MFHInvestmentCaseAdminInputEdit],
            },
            {
                path: 'dd-answer-suggestions',
                name: 'config.dd-answer-suggestions',
                element: <DDAnswerSuggestionsPage />,
            },
            {
                path: 'renovation-strategy-scenarios',
                name: 'config.renovation-strategy-scenarios',
                element: <RenovationStrategyScenariosPage />,
                permissions: [Permission.MFHInvestmentCaseAdminInputEdit],
            },
            {
                path: 'sourcing-criteria',
                name: 'config.sourcing-criteria',
                element: <SourcingCriteriaPage />,
                permissions: [Permission.AdministrationRulesView],
            },
        ],
    },
    {
        path: 'investment-case-config',
        element: <Navigate to="/configuration/investment-case-defaults" replace />,
        permissions: [Permission.MFHInvestmentCaseAdminInputEdit],
    },
    {
        path: 'investment-case-asset-partner-profiles',
        element: <Navigate to="/configuration/asset-partner-ic-profiles" replace />,
        permissions: [Permission.MFHInvestmentCaseAdminInputEdit],
    },
];
